// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"flag-icon-css-es-ca\" viewBox=\"0 0 640 480\"> <path fill=\"#fcdd09\" d=\"M0 0h640v480H0z\"/> <path stroke=\"#da121a\" stroke-width=\"60\" d=\"M0 90h810m0 120H0m0 120h810m0 120H0\" transform=\"scale(.79012 .88889)\"/> </svg> ";
// Exports
module.exports = code;